import React, { useEffect, useState, useRef ,useCallback} from 'react';
import { Avatar, Box, Button, Grid, Checkbox, TextField, Typography, Dialog, DialogActions, DialogContent, DialogTitle, Alert } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Geocode from "react-geocode";
import { AddCircle, RemoveCircle,  Warning, GpsFixed, Error } from '@mui/icons-material';
import Check from '@mui/icons-material/Check';
import CheckBoxOutlineBlank from '@mui/icons-material/CheckBoxOutlineBlank';
import moment from 'moment';
import useServices from '../../services/useServices';
import { getSessionData, setSessionData, updateManifestFile, getGPSAccuracySetting, shouldEnforceGPSAccuracy, shouldBlockForGPSAccuracy, GPS_ACCURACY_THRESHOLD,getStateAbbreviation } from '../../utils/utils';
import MapServices from '../../services/MapServices';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import AddressPicker from '../../components/AddressPicker';
import GPSAccuracyDialog from '../../components/GPSAccuracyDialog'
import imageCompression from 'browser-image-compression';
import AutoComplete from '../../components/GoogleMaps/Autocomplete';
import ImageUploader from '../../components/ImageUploader';
import FormSubmissionHandler from './FormSubmissionHandler'
import LocationPermissionDialog from './LocationPermissionDialog'
import LocationVerificationDialog from '../../components/LocationVerificationDialog'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useGoogleMaps } from '../../utils/GoogleMapsProvider';
import { logAnalyticsEvent, setAnalyticsUserId } from '../../utils/analytics';
import { validateAddress } from '../../services/addressValidation';
Geocode.setApiKey(process.env.REACT_APP_GOOGLE_API_KEY);
Geocode.enableDebug();

const requestPageStyles = makeStyles({
    labelName: { fontWeight: "600", marginBottom: "8px" },
    valueStyle: { marginBottom: "15px !important" },
    captureStyle: { color: "black", fontSize: "2.5rem !important" },
    avatar: { height: "100px !important", width: "200px !important" },
    requestButton: {
        backgroundColor: "green",
        '&:hover': { backgroundColor: "green" }
    },
    buttonStyle: { color: "black" }
});



const NewRequest = () => {
    const classes = requestPageStyles();
    const navigate = useNavigate();
    const location = useLocation();
    const { screen: screenParam } = useParams();
    const accountId = getSessionData('userID');
    const uniqueCode = getSessionData('token');
    updateManifestFile(accountId, uniqueCode);
    
    // Existing state
    const [profilePics, setProfilePics] = useState([]);
    const [thumbnailImgs, setThumbnailImgs] = useState([]);
    const [towCount, setTowCount] = useState(1);
    const [truckCount, setTruckCount] = useState(1);
    const [screen, setScreen] = useState(1);
    const [userData, setUserData] = useState({});
    const [mapApi, setMapApi] = useState(null);
    const [mapInstance, setMapInstance] = useState(null);
    const [isValid, setIsValid] = useState(false);
    const [scanData, setScanData] = useState(null);
    const [stopStream, setStopStream] = useState(false);
    const [isGpsEnabled, setIsGpsEnabled] = useState(false);
    const [openScanner, setOpenScanner] = useState(false);
    const [list, setList] = useState([]);
    const [checked, setChecked] = useState(false);
    const [isSelected, setSelected] = useState(false);
    const [pickupLocationDetails, setPickupLocationDetails] = useState({
        addressLine: "", area: "", city: "", state: "", postalCode: "", landmark: ""
    });
    const [formData, setFormData] = useState({ pickUpAddress: "", dropOffAddress: "" });
    const [pickupLocation, setPickupLocation] = useState([33.4484, -112.0740]); // Phoenix, AZ default
    const { post } = useServices();
    const [note, setNote] = useState("");
    const [openNoteDialog, setOpenNoteDialog] = useState(false);
    const [savedNote, setSavedNote] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitError, setSubmitError] = useState(null);
    const [showLocationAlert, setShowLocationAlert] = useState(false);
    const [responseMessage, setResponseMessage] = useState("");

    // GPS validation state
    const [locationValidation, setLocationValidation] = useState({
        coordinates: null,
        withinServiceArea: true,
        accuracy: null,
        accuracyStatus: 'unknown',
        source: 'manual'
    });
    const [showLocationVerification, setShowLocationVerification] = useState(false);
    const [pendingLocationData, setPendingLocationData] = useState(null);
    const [locationWarnings, setLocationWarnings] = useState([]);
    const [gpsAccuracy, setGpsAccuracy] = useState(null);
    const [accuracyStatus, setAccuracyStatus] = useState('unknown');

    // GPS Accuracy Dialog State
    const [showGPSAccuracyDialog, setShowGPSAccuracyDialog] = useState(false);
    const [gpsAccuracySetting, setGpsAccuracySetting] = useState('Off');
    const [isBlockedByGPSAccuracy, setIsBlockedByGPSAccuracy] = useState(false);
    const [manualEntryDueToPoorGPS, setManualEntryDueToPoorGPS] = useState(false);
    
    // NEW: Location services status
    const [locationServicesEnabled, setLocationServicesEnabled] = useState(true);
    const [locationServicesChecked, setLocationServicesChecked] = useState(false);
    const [showLocationPermissionDialog, setShowLocationPermissionDialog] = useState(false);

    const { isLoaded: isGoogleMapsLoaded } = useGoogleMaps();

    const trackGPSInitialization = (status, details = {}) => {
  logAnalyticsEvent('gps_initialization', {
    status, // 'started', 'success', 'failed'
    ...details,
    gpsAccuracySetting,
    locationServicesEnabled
  });
};

// Track GPS accuracy issues
const trackGPSAccuracy = (accuracy, source) => {
  const accuracyStatus = accuracy > 300 ? 'poor' : 
                        accuracy > GPS_ACCURACY_THRESHOLD ? 'medium' : 'good';
  
  logAnalyticsEvent('gps_accuracy_measured', {
    accuracy: Math.round(accuracy),
    accuracyStatus,
    source, // 'initial_load', 'manual_gps_button', 'autocomplete'
    meetsThreshold: accuracy <= GPS_ACCURACY_THRESHOLD,
    threshold: GPS_ACCURACY_THRESHOLD,
    isBlockedByAccuracy: accuracy > GPS_ACCURACY_THRESHOLD && shouldBlockForGPSAccuracy()
  });
};

// Track location errors
const trackLocationError = (errorType, errorMessage, context) => {
  logAnalyticsEvent('location_error', {
    errorType, // 'permission_denied', 'timeout', 'unavailable', 'unknown'
    errorMessage,
    context, // 'page_load', 'manual_request', 'autocomplete'
    gpsAccuracySetting,
    browserPermissionState: locationServicesEnabled ? 'granted' : 'denied'
  });
};

// Track autocomplete selection
const trackAutocompleteSelection = (type, hasGpsSync) => {
  logAnalyticsEvent('autocomplete_selection', {
    addressType: type, // 'intersection', 'address', 'other'
    gpsCoordinatesUpdated: hasGpsSync,
    currentAccuracy: gpsAccuracy,
    locationSource: locationValidation.source
  });
};

// Track form submission with location data
const trackFormSubmission = () => {
  logAnalyticsEvent('tow_request_submitted', {
    gpsAccuracy: gpsAccuracy || 'not_available',
    accuracyStatus,
    locationSource: locationValidation.source,
    withinServiceArea: locationValidation.withinServiceArea,
    manualEntryDueToPoorGPS,
    gpsAccuracySetting,
    locationServicesEnabled,
    hasNote: !!savedNote,
    towCount,
    truckCount,
    flatbedRequired: checked
  });
};

    // Load GPS accuracy setting on component mount
    useEffect(() => {
        const setting = getGPSAccuracySetting();
        setGpsAccuracySetting(setting);
        console.log('GPS Accuracy Setting loaded:', setting);
    }, []);

 const checkLocationServicesAvailability = useCallback(async () => {
    if (!navigator.geolocation) {
        console.log('â›” Geolocation not supported');
        setLocationServicesEnabled(false);
        setLocationServicesChecked(true);
        return false;
    }
    
    try {
        // For Android Chrome, permission.query is unreliable in incognito
        // So we skip it and assume permission is available
        const isAndroidChrome = /Android/i.test(navigator.userAgent) && 
                               /Chrome/i.test(navigator.userAgent);
        
        if (isAndroidChrome) {
            console.log('ðŸ“ Android Chrome detected - bypassing permission check');
            setLocationServicesEnabled(true);
            setLocationServicesChecked(true);
            return true;
        }
        
        // Original logic for other browsers
        if (navigator.permissions) {
            const result = await navigator.permissions.query({ name: 'geolocation' });
            const enabled = result.state === 'granted';
            console.log('ðŸ“ Location services check:', result.state);
            setLocationServicesEnabled(enabled);
            setLocationServicesChecked(true);
            
            if (!enabled) {
                const setting = getGPSAccuracySetting();
                if (setting === 'Off' || setting === 'Manual') {
                    console.log('ðŸ“ Location disabled - showing dialog with Manual option');
                    setShowLocationPermissionDialog(true);
                } else if (setting === 'Forced') {
                    console.log('ðŸ“ Location disabled - showing dialog with Refresh only');
                    setShowLocationPermissionDialog(true);
                }
            }
            
            return enabled;
        }
        return false;
    } catch (error) {
        console.error('Error checking location services:', error);
        setLocationServicesEnabled(false);
        setLocationServicesChecked(true);
        return false;
    }
}, []);

    // GPS Accuracy Check Function
    const checkGPSAccuracy = useCallback((accuracy) => {
        const setting = getGPSAccuracySetting();
        
        console.log(`ðŸŽ¯ GPS Accuracy Check - Setting: ${setting}, Accuracy: Â±${accuracy}m, Threshold: Â±${GPS_ACCURACY_THRESHOLD}m`);
        
        // No checking needed if setting is "Off"
        if (setting === 'Off') {
            console.log('GPS accuracy setting is Off - no enforcement');
            return true;
        }
        
        // Check if accuracy meets requirement
        if (accuracy <= GPS_ACCURACY_THRESHOLD) {
            console.log(`âœ… GPS accuracy (Â±${accuracy}m) meets requirement (Â±${GPS_ACCURACY_THRESHOLD}m)`);
            setShowGPSAccuracyDialog(false);
            setIsBlockedByGPSAccuracy(false);
            return true;
        }
        
        // Accuracy does not meet requirement
        console.log(`âš ï¸ GPS accuracy (Â±${accuracy}m) does not meet requirement (Â±${GPS_ACCURACY_THRESHOLD}m)`);
        
        if (setting === 'Forced') {
            console.log('ðŸš« Forced mode - blocking progression until accuracy improves');
            setShowGPSAccuracyDialog(true);
            setIsBlockedByGPSAccuracy(true);
            return false;
        } else if (setting === 'Manual') {
            console.log('âš¡ Manual mode - showing warning but allowing override');
            setShowGPSAccuracyDialog(true);
            setIsBlockedByGPSAccuracy(false);
            return false;
        }
        
        return true;
    }, []);

    // Handle location validation from AddressPicker
    const handleLocationValidation = (validationData) => {
        setLocationValidation(validationData);
        
        // Handle location services requirement
        if (validationData.requiresLocationServices) {
            console.log('ðŸ“ Location services required - showing permission dialog');
            setShowLocationPermissionDialog(true);
            return;
        }
        
        // GPS Accuracy Check on location validation
        if (validationData.source === 'gps' && validationData.accuracy) {
            const accuracyCheckPassed = checkGPSAccuracy(validationData.accuracy);
            
            // Don't show verification dialog if GPS accuracy dialog is handling it
            if (shouldEnforceGPSAccuracy() && !accuracyCheckPassed) {
                return;
            }
        }
        
        // Check if we need to show verification dialog (for other issues)
        const needsVerification = 
            !validationData.withinServiceArea && 
            (!shouldEnforceGPSAccuracy() || validationData.accuracy <= GPS_ACCURACY_THRESHOLD);
            
        if (needsVerification && validationData.source === 'gps') {
            setPendingLocationData(validationData);
            setShowLocationVerification(true);
        }
        
        // Update warnings (excluding GPS accuracy warnings if handled by new dialog)
        const warnings = [];
        if (!validationData.withinServiceArea) {
            warnings.push({
                type: 'warning',
                message: 'Location is outside Arizona service area'
            });
        }
        
        // Only show accuracy warnings here if GPS accuracy enforcement is off
        if (!shouldEnforceGPSAccuracy() && validationData.accuracy) {
            if (validationData.accuracy > 1000) {
                warnings.push({
                    type: 'error', 
                    message: `Very poor GPS accuracy: Â±${Math.round(validationData.accuracy)}m`
                });
            } else if (validationData.accuracy > 300) {
                warnings.push({
                    type: 'warning',
                    message: `Low GPS accuracy: Â±${Math.round(validationData.accuracy)}m`
                });
            }
        }
        
        setLocationWarnings(warnings);
    };

    // Handle accuracy changes from AddressPicker
    const handleAccuracyChange = (accuracy, status) => {
        setGpsAccuracy(accuracy);
        setAccuracyStatus(status);
        
        // Trigger GPS accuracy check when accuracy changes
        if (accuracy && shouldEnforceGPSAccuracy()) {
            checkGPSAccuracy(accuracy);
        }
    };

    // Handle GPS Accuracy Dialog Actions
    const handleGPSAccuracyRefresh = () => {
        console.log('GPS Accuracy Dialog: Refresh requested');
        // Full page refresh as specified
        window.location.reload();
    };

    const handleGPSAccuracyManualEntry = () => {
        console.log('GPS Accuracy Dialog: Manual entry selected');
        setShowGPSAccuracyDialog(false);
        setIsBlockedByGPSAccuracy(false);
        setManualEntryDueToPoorGPS(true);
        
        console.log('Manual entry allowed - user can proceed with current location');
    };

    // Handle location permission dialog
    const handleLocationPermissionRefresh = () => {
        console.log('Location Permission Dialog: Refresh requested');
        window.location.reload();
    };

    const handleLocationPermissionManualEntry = () => {
        console.log('Location Permission Dialog: Manual entry selected');
        setShowLocationPermissionDialog(false);
        // Allow manual entry even without location services
        setLocationServicesEnabled(false);
    };

    // Handle location verification dialog result
    const handleLocationVerificationResult = (result) => {
        if (result.confirmed) {
            if (result.editedAddress) {
                const addressParts = result.editedAddress.split(',').map(part => part.trim());
                setPickupLocationDetails({
                    ...pickupLocationDetails,
                    addressLine: addressParts[0] || '',
                    city: addressParts[1] || pickupLocationDetails.city,
                    state: addressParts[2] || pickupLocationDetails.state,
                    postalCode: addressParts[3] || pickupLocationDetails.postalCode
                });
            }
            
            console.log('Location confirmed with validation:', {
                ...pendingLocationData,
                userConfirmed: true,
                supervisorOverride: result.supervisorOverride
            });
        }
        
        setShowLocationVerification(false);
        setPendingLocationData(null);
    };

    // Handle retry GPS from verification dialog
    const handleRetryGPS = () => {
        setShowLocationVerification(false);
        setPendingLocationData(null);
    };

    // MAIN GPS INITIALIZATION - Enhanced location detection on page load
    useEffect(() => {
        const initializeLocationServices = async () => {
            console.log('ðŸŽ¯ NewRequest: Initializing location services...');
            
            // Step 1: Check location services availability
            const servicesEnabled = await checkLocationServicesAvailability();
            
            if (!servicesEnabled) {
                console.log('âŒ Location services not available - using default location');
                setToDefaultLocation();
                return;
            }
            
            // Step 2: Automatically pull GPS if services are enabled
            console.log('âœ… Location services available - starting automatic GPS pull...');
            await requestCurrentLocation();
        };

        const requestCurrentLocation = async () => {
            if (!navigator.geolocation) {
                console.log('Geolocation not supported, setting default location');
                setToDefaultLocation();
                return;
            }

            console.log('ðŸŽ¯ NewRequest: Starting automatic GPS pull...');
            
            const highAccuracyOptions = {
                enableHighAccuracy: true,
                timeout: 15000,
                maximumAge: 0
            };

            try {
                const position = await getCurrentPositionPromise(highAccuracyOptions);
                handleSuccessfulLocation(position, 'high-accuracy');
            } catch (error) {
                console.warn('High accuracy GPS failed, trying standard GPS...', error);
                
                const standardOptions = {
                    enableHighAccuracy: false,
                    timeout: 10000,
                    maximumAge: 5000
                };

                try {
                    const position = await getCurrentPositionPromise(standardOptions);
                    handleSuccessfulLocation(position, 'standard');
                } catch (fallbackError) {
                    console.error('All GPS attempts failed:', fallbackError);
                    handleLocationError(fallbackError);
                }
            }
        };

        const getCurrentPositionPromise = (options) => {
            return new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(resolve, reject, options);
            });
        };

       const handleSuccessfulLocation = (position, attemptType) => {
    const { latitude, longitude, accuracy } = position.coords;
    console.log(`âœ… NewRequest GPS Success (${attemptType}): ${latitude}, ${longitude}, Accuracy: Â±${accuracy}m`);
    trackGPSInitialization('success', {
    attemptType,
    accuracy: Math.round(accuracy),
    latitude: latitude.toFixed(6),
    longitude: longitude.toFixed(6)
  });
  
  // Track GPS accuracy
  trackGPSAccuracy(accuracy, 'initial_load');
    
    setIsGpsEnabled(true);
    setPickupLocation([latitude, longitude]);
    setGpsAccuracy(accuracy);
    
    let status = 'high';
    if (accuracy > 300) status = 'low';
    else if (accuracy > GPS_ACCURACY_THRESHOLD) status = 'medium';
    setAccuracyStatus(status);
    
    // **ADD THIS: Fetch address automatically when GPS succeeds**
    if (typeof fetchAddressOnPointerChange === 'function') {
        console.log('ðŸ“ Fetching address for GPS coordinates...');
        setTimeout(() => {
            fetchAddressOnPointerChange(latitude, longitude);
        }, 500); // Small delay to ensure maps API is ready
    }
    
    if (shouldEnforceGPSAccuracy()) {
        console.log('ðŸ” Checking GPS accuracy on page load...');
        checkGPSAccuracy(accuracy);
    }
    
    setShowLocationAlert(false);
    
    if (accuracy > GPS_ACCURACY_THRESHOLD) {
        console.warn(`âš ï¸ GPS accuracy on load (Â±${accuracy}m) does not meet requirement (Â±${GPS_ACCURACY_THRESHOLD}m)`);
    } else {
        console.log(`âœ… GPS accuracy on load (Â±${accuracy}m) meets requirement (Â±${GPS_ACCURACY_THRESHOLD}m)`);
    }
};

        const handleLocationError = (error) => {
            let errorMessage = 'GPS Error: ';
  let errorType = 'unknown';
  
  switch (error.code) {
    case error.PERMISSION_DENIED:
      errorMessage += 'Location permission denied';
      errorType = 'permission_denied';
      break;
    case error.POSITION_UNAVAILABLE:
      errorMessage += 'Location information unavailable';
      errorType = 'unavailable';
      break;
    case error.TIMEOUT:
      errorMessage += 'Location request timed out';
      errorType = 'timeout';
      break;
  }
  
  // Track the error
  trackLocationError(errorType, errorMessage, 'page_load');
            console.warn(errorMessage);
            setIsGpsEnabled(false);
            setToDefaultLocation();
            
            if (error.code === error.PERMISSION_DENIED) {
                setShowLocationPermissionDialog(true);
            }
        };

        const setToDefaultLocation = () => {
            const defaultLat = 33.4484;
            const defaultLng = -112.0740;
            console.log('ðŸ“ Setting default location: Phoenix, AZ');
            
            setPickupLocation([defaultLat, defaultLng]);
            setGpsAccuracy(null);
            setAccuracyStatus('unknown');
        };

        // Initialize location services and GPS
        initializeLocationServices();

    }, [checkGPSAccuracy, checkLocationServicesAvailability]);

    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    const mapRef = useRef(null);
    const markerRef = useRef(null);
    
    const createMapOptions = () => {
        const baseOptions = {
            gestureHandling: 'greedy',
            mapTypeId: 'satellite',
            rotateControl: false,
            tilt: 0,
            fullscreenControl: false,
            disableDefaultUI: true,
            zoomControl: true,
        };

        if (window.google && window.google.maps && window.google.maps.ControlPosition) {
            baseOptions.zoomControlOptions = {
                position: window.google.maps.ControlPosition.RIGHT_CENTER,
            };
        }

        return baseOptions;
    };
    
    useEffect(() => {
        const data = getSessionData("userData") || JSON.stringify({});
        setUserData(JSON.parse(data));
    }, []);

    const updateMapAndMarker = (lat, lng) => {
        if (mapRef.current && markerRef.current) {
            mapRef.current.panTo({ lat, lng });
            markerRef.current.setPosition({ lat, lng });
            setPickupLocation([lat, lng]);
        }
    };
useEffect(() => {
  const userID = getSessionData('userID');
  if (userID) {
    setAnalyticsUserId(userID);
  }
}, []);
    useEffect(() => {
        if (pickupLocationDetails.addressLine && pickupLocationDetails.city && pickupLocationDetails.state) {
            setIsValid(true);
        } else {
            setIsValid(false);
        }
    }, [pickupLocationDetails]);

    useEffect(() => {
        if (mapApi && mapApi.Geocoder && pickupLocation.length === 2 && !isSelected) {
            console.log('ðŸ—ºï¸ Fetching address from geocode for:', pickupLocation);
            fetchAddressFromGeocode();
        }
    }, [mapApi, pickupLocation, isSelected]);

    const handleCapture = async ({ target }) => {
        const files = Array.from(target.files);
        const newProfilePics = [...profilePics];
        const newThumbnailImgs = [...thumbnailImgs];

        for (const file of files) {
            const size = getFileSize(file.size);
            if (size > 1) {
                const compressedFile = await imageCompression(file, { maxSizeMB: 1, maxWidthOrHeight: 1920 });
                newProfilePics.push(compressedFile);
                newThumbnailImgs.push(URL.createObjectURL(compressedFile));
            } else {
                newProfilePics.push(file);
                newThumbnailImgs.push(URL.createObjectURL(file));
            }
        }

        setProfilePics(newProfilePics);
        setThumbnailImgs(newThumbnailImgs);
    };

    const getFileSize = (_size) => {
        const cnvertSizeTOMB = _size / 1048576;
        return cnvertSizeTOMB;
    };

    const removeTowingCount = () => {
        if (towCount > 1) setTowCount(towCount - 1);
        setTruckCount(1);
    };


    
    const addTowingCount = () => {
        setTowCount(towCount + 1);
    };

    const removeTruckCount = () => {
        if (truckCount > 1) setTruckCount(truckCount - 1);
    };

    const addTruckCount = () => {
        if (towCount > truckCount) setTruckCount(truckCount + 1);
    };

    const handleSubmit = async () => {
        // Track form submission
  trackFormSubmission();
        // Block submission if GPS accuracy is enforced and not met
        if (shouldBlockForGPSAccuracy() && gpsAccuracy && gpsAccuracy > GPS_ACCURACY_THRESHOLD) {
            console.log('ðŸš« Blocking form submission due to poor GPS accuracy in Forced mode');
            setShowGPSAccuracyDialog(true);
            return;
        }

        setIsSubmitting(true);
        setSubmitError(null);

        try {
            const userID = getSessionData("userID")
            const token = getSessionData("token")

            if (userID) {
                const base64Array = await getBase64(profilePics);
                const VIN = list.filter(item => item.isValid).map(item => item.value)
                const fileType = profilePics && profilePics.length > 0 && profilePics[0].type ? profilePics[0].type.split("/")[1] : null;
                const deviceId = localStorage.getItem('fcm_token');

                const stateAbbreviation = getStateAbbreviation(pickupLocationDetails.state);
                console.log(`Converting state from "${pickupLocationDetails.state}" to "${stateAbbreviation}" for submission`);

                // Validate pickup address before submission.
                // Mirror dispatchReview.jsx:1040-1042 — if the address text came from
                // Google (autocomplete pick, GPS-button reverse-geocode, or map-pin drag,
                // all of which set isSelected=true), Google has already given us a
                // standardized address + coordinates, so a second Geocoding round-trip
                // would only add Google's own PARTIAL false-negatives (e.g. "8377 Vía de
                // Ventura" when Google's index has the street but not that house number).
                // Manual entry still goes through validateAddress.
                let pickupAddrVerified = null;
                try {
                    if (isSelected) {
                        pickupAddrVerified = 1;
                    } else if (pickupLocationDetails.addressLine && pickupLocationDetails.addressLine.trim() !== '') {
                        const pickupResult = await validateAddress(
                            pickupLocationDetails.addressLine,
                            pickupLocationDetails.city,
                            stateAbbreviation,
                            pickupLocationDetails.postalCode
                        );
                        pickupAddrVerified = pickupResult.verified ? 1 : 0;
                    }
                } catch (err) {
                    console.error('Address validation error:', err);
                }

                const requestBody = {
                    receiverDate: moment().format("MM/DD/YYYY"),
                    pickupAddrLine1: pickupLocationDetails.addressLine,
                    pickupCity: pickupLocationDetails.city,
                    pickupState: stateAbbreviation,
                    pickupZipcode: pickupLocationDetails.postalCode,
                    pickupLandmark: pickupLocationDetails.landmark,
                    pickupLatLong: pickupLocation.join(','),
                    requestTime: moment().format("MM/DD/YYYY HH:mm:ss"),
                    receivedTime: moment().format("MM/DD/YYYY HH:mm:ss"),
                    pic: base64Array,
                    duplicateCopies: towCount,
                    noOfTrucks: truckCount,
                    VIN,
                    securityID: getSessionData("securityID"),
                    isGpsEnabled: isGpsEnabled,
                    deviceId: deviceId || getSessionData("uniqueDeviceId"),
                    savedNote: savedNote,
                    // GPS validation fields
                    gpsAccuracy: gpsAccuracy,
                    accuracyStatus: accuracyStatus,
                    locationSource: locationValidation.source,
                    withinServiceArea: locationValidation.withinServiceArea,
                    locationValidated: locationValidation.withinServiceArea && (accuracyStatus === 'high' || accuracyStatus === 'medium'),
                    manualEntryDueToPoorGPS: manualEntryDueToPoorGPS,
                    gpsAccuracySetting: gpsAccuracySetting,
                    locationServicesEnabled: locationServicesEnabled,
                    // Address verification result
                    pickupAddrVerified: pickupAddrVerified
                }
                
                console.log('ðŸ“¤ Submitting request with abbreviated state:', {
                    originalState: pickupLocationDetails.state,
                    abbreviatedState: stateAbbreviation,
                    gpsAccuracy: gpsAccuracy,
                    accuracyStatus: accuracyStatus
                });
                
                const res = await post(`ars/directCall/${userID}/${token}/${checked}`, requestBody)
                setResponseMessage(res.data.message);
                
                setTimeout(() => {
                }, 90000);
                
                setProfilePics([])
                const serviceOrder = res.data.resp.split(',')
                const serviceOrders = getSessionData('serviceOrders')
                const serviceOrdersArray = serviceOrders ? JSON.parse(serviceOrders) : []
                serviceOrdersArray.push(...serviceOrder)
                setSessionData(serviceOrdersArray, 'serviceOrders')
                handleNext()
            } else {
                throw 'user not valid';
            }
        } catch (error) {
            console.log(error);
            setSubmitError('Unable to submit request. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const setFormCoordinates = (lat, lng) => {
        setPickupLocation([lat, lng]);
        
        if (mapRef.current) {
            mapRef.current.panTo({ lat, lng });
            if (markerRef.current) {
                markerRef.current.setPosition({ lat, lng });
            }
        }
    };

    const gotoHome = () => {
        navigate("/");
    };

    const gotoTrackOrder = () => {
        navigate("/trackOrder");
    };

    const onChangeHandler = (e, key) => {
        formData[key] = e.target.value;
        setFormData({ ...formData });
    };

    const getBase64 = (files) => {
        if (!Array.isArray(files)) files = [files];

        const promises = files.map(file => {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function () {
                    resolve(reader.result);
                };
                reader.onerror = function (error) {
                    reject(error);
                };
            });
        });

        return Promise.all(promises);
    };

    const onChangePickupHandler = (e, key) => {
        pickupLocationDetails[key] = e.target.value;
        setPickupLocationDetails({ ...pickupLocationDetails });
        // Manual edit of the address text invalidates the "address came from Google"
        // trust signal — otherwise a user could pick "8377 X St" from autocomplete,
        // edit it to "9999 X St", and the submit would still skip validation.
        if (key === 'addressLine') {
            setSelected(false);
        }
    };

    const getLocationDetails = (locationObj) => {
        setPickupLocation([locationObj.lat, locationObj.lng]);
    };

    // Note dialog handlers
    const handleOpenNoteDialog = () => {
        setOpenNoteDialog(true);
    };

    const handleCloseNoteDialog = () => {
        setOpenNoteDialog(false);
    };

    const handleSaveNote = () => {
        if (note.trim()) {
            setSavedNote(note);
            setOpenNoteDialog(false);
        } else {
            console.warn("Note is empty, please add some content.");
        }
    };

    // Navigation handlers
    useEffect(() => {
        window.history.replaceState({ screen }, '', '');

        const handlePopState = (event) => {
            const newScreen = event.state?.screen;

            if (openScanner) {
                setOpenScanner(false);
                setStopStream(true);
            } else if (newScreen !== undefined && newScreen > 0) {
                setScreen(newScreen);
            } else {
                navigate("/trackOrder");
            }
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [navigate, openScanner, screen]);

    const handleBack = (fromPopState = false) => {
        if (openScanner) {
            setOpenScanner(false);
            setStopStream(true);
        } else {
            const newScreen = screen - 1;
            if (newScreen >= 1) {
                setScreen(newScreen);
                if (!fromPopState) {
                    window.history.replaceState({ screen: newScreen }, '', '');
                }
            } else {
                navigate("/trackOrder");
            }
        }
    };

    const handleNext = () => {
        // Block progression if GPS accuracy is enforced and not met
        if (screen === 1 && shouldBlockForGPSAccuracy() && gpsAccuracy && gpsAccuracy > GPS_ACCURACY_THRESHOLD) {
            console.log('ðŸš« Blocking progression to next screen due to poor GPS accuracy in Forced mode');
            setShowGPSAccuracyDialog(true);
            return;
        }

        const newScreen = screen + 1;
        setScreen(newScreen);
        window.history.pushState({ screen: newScreen }, '', '');
    };

    const updateFormStateData = (results) => {
        if (results) {
            let addressArray = results.address_components,
                addressLine = MapServices.getAddressLine(addressArray) || '',
                postalCode = MapServices.getPostalCode(addressArray) || '',
                city = MapServices.getCity(addressArray) || '',
                area = MapServices.getArea(addressArray) || '',
                state = MapServices.getState(addressArray) || '';
            if (!addressLine) {
                // FIX: Use getCleanAddressLine to strip business/neighborhood names
                // instead of formatted_address.split(',')[0] which could return
                // "Moore Therapy & Rehab" instead of "2500 S Power Rd"
                addressLine = MapServices.getCleanAddressLine(addressArray, results.formatted_address);
            }
            setFormData({ ...formData, pickUpAddress: `${area},${city},${state}` });
            setPickupLocationDetails({ addressLine, area, city, state, postalCode, landmark: "" });
        }
    };

    const fetchAddressFromGeocode = () => {
        if (!mapApi || !mapApi.Geocoder) {
            console.log('âš ï¸ Google Maps API not ready yet for geocoding');
            return;
        }
        
        const geocoder = new mapApi.Geocoder();
        geocoder.geocode({ 'location': { lat: pickupLocation[0], lng: pickupLocation[1] } }, (results, status) => {
            if (status === 'OK' && results && results.length > 0) {
                // FIX: Use getBestGeocodeResult to pick street-level result
                // instead of results[0] which could be an establishment/neighborhood
                const bestResult = MapServices.getBestGeocodeResult(results);
                updateFormStateData(bestResult);
                setSelected(true);
            }
        });
    };

    const fetchAddressOnPointerChange = async (lat, lng) => {
        if (!window.google?.maps?.Geocoder) {
            console.log('âš ï¸ Google Maps Geocoder not ready yet');
            return;
        }
        
        try {
            const geocoder = new window.google.maps.Geocoder();
            
            // FIX: Resolve the FULL results array, not just results[0]
            const allResults = await new Promise((resolve) => {
                geocoder.geocode({ location: { lat, lng } }, (results, status) => {
                    if (status === 'OK' && results && results.length > 0) {
                        resolve(results);
                    } else {
                        console.warn('âš ï¸ Geocoding failed with status:', status);
                        resolve(null);
                    }
                });
            });
    
            if (allResults) {
                // FIX: Pick the best street-level result from all results
                const result = MapServices.getBestGeocodeResult(allResults);

                const streetNumber = result.address_components.find(comp => 
                    comp.types.includes('street_number')
                )?.long_name || '';
    
                const streetName = result.address_components.find(comp => 
                    comp.types.includes('route')
                )?.long_name || '';
    
                if (streetNumber && streetName) {
                    setPickupLocationDetails({
                        addressLine: `${streetNumber} ${streetName}`,
                        area: MapServices.getArea(result.address_components) || '',
                        city: MapServices.getCity(result.address_components) || '',
                        state: MapServices.getState(result.address_components) || '',
                        postalCode: MapServices.getPostalCode(result.address_components) || '',
                        landmark: ''
                    });
                    // GPS button / map-pin reverse-geocode succeeded with a full street
                    // address. Mark as Google-trusted so the submit-time short-circuit
                    // skips the redundant Geocoding round-trip (which can return PARTIAL
                    // for the same address Google just gave us).
                    setSelected(true);
                    return;
                }

                const streets = result.address_components.filter(comp => 
                    comp.types.includes('route')
                );

                if (streets.length === 1) {
                    const radius = 10;
                    const nearbyResult = await new Promise((resolve) => {
                        geocoder.geocode({
                            location: { lat, lng },
                            radius: radius
                        }, (results, status) => {
                            if (status === 'OK' && results) {
                                resolve(results);
                            } else {
                                resolve([]);
                            }
                        });
                    });

                    const nearbyStreets = new Set();
                    nearbyResult.forEach(place => {
                        place.address_components
                            .filter(comp => comp.types.includes('route'))
                            .forEach(street => nearbyStreets.add(street.long_name));
                    });

                    const streetArray = Array.from(nearbyStreets);
                    if (streetArray.length >= 2) {
                        setPickupLocationDetails({
                            addressLine: `Intersection of ${streetArray[0]} and ${streetArray[1]}`,
                            area: MapServices.getArea(result.address_components) || '',
                            city: MapServices.getCity(result.address_components) || '',
                            state: MapServices.getState(result.address_components) || '',
                            postalCode: MapServices.getPostalCode(result.address_components) || '',
                            landmark: ''
                        });
                        // Intersection from Google's nearby reverse-geocode → trusted.
                        setSelected(true);
                        return;
                    }
                }

                // FIX: Use getCleanAddressLine to strip business/neighborhood names
                const cleanAddress = MapServices.getCleanAddressLine(result.address_components, result.formatted_address);
                setPickupLocationDetails({
                    addressLine: cleanAddress,
                    area: MapServices.getArea(result.address_components) || '',
                    city: MapServices.getCity(result.address_components) || '',
                    state: MapServices.getState(result.address_components) || '',
                    postalCode: MapServices.getPostalCode(result.address_components) || '',
                    landmark: ''
                });
                // Reverse-geocode produced a clean address line from Google data → trusted.
                // Only mark trusted when the address is non-empty; the empty-fallback below
                // ('Address not found' / 'Error finding address') stays untrusted so the
                // submit path doesn't auto-verify a junk string.
                if (cleanAddress && cleanAddress.trim() !== '') {
                    setSelected(true);
                }
            } else {
                setPickupLocationDetails({
                    addressLine: 'Address not found',
                    area: '', city: '', state: '', postalCode: '', landmark: ''
                });
                // Explicitly keep untrusted — no real address to trust.
                setSelected(false);
            }
        } catch (error) {
            console.error('âŒ Error in fetchAddressOnPointerChange:', error);
            setPickupLocationDetails({
                addressLine: 'Error finding address',
                area: '', city: '', state: '', postalCode: '', landmark: ''
            });
            setSelected(false);
        }
    };

    const apiHasLoaded = (map, maps) => {
        setMapApi(maps);
        setMapInstance(map);
        mapRef.current = map;

        markerRef.current = new maps.Marker({
            position: { lat: pickupLocation[0], lng: pickupLocation[1] },
            map: mapRef.current,
            draggable: true,
        });

        markerRef.current.addListener('dragend', (event) => {
            const newLat = event.latLng.lat();
            const newLng = event.latLng.lng();
            fetchAddressOnPointerChange(newLat, newLng);
        });
    };

    const addPlace = (place) => {
        setSelected(true); // Prevent useEffect from re-geocoding and overwriting with business/neighborhood names
        setPickupLocation([]);
        setPickupLocation([place.geometry.location.lat() || '', place.geometry.location.lng() || '']);
        updateFormStateData(place);
    };

    function updateList(items) {
        let newList = [].concat(list, items);
        setList(newList);
    }

    function validateValue(value, validatedItems) {
        let isValid = true;
        const valueInt = value;
        const selectedValues = list.map((item) => item.value);
        const validatedValues = validatedItems.map((item) => item.value);
        if (selectedValues.indexOf(valueInt) !== -1 || validatedValues.indexOf(valueInt) !== -1) {
            isValid = false;
        }
        return isValid;
    }

    function validateInput(event, inputs, reason) {
        if ('createOption' == reason) {
            let id = list.length;
            let validatedItems = [];
            let isValid = validateValue(inputs, validatedItems);
            if (isValid) {
                validatedItems.push({
                    id: ++id,
                    value: inputs,
                    isValid
                });
                updateList(validatedItems);
            }
        } else if ('removeOption' == reason) {
            let listById = {};
            for (let item of list) {
                listById[item.id] = item;
            }

            let newList = inputs.map((id) => listById[id]);
            setList(newList);
        } else if ('clear' == reason) {
            setList([]);
        }
    }

    return (
        <>
            <Box sx={{ flexGrow: 1, paddingLeft: 3, paddingRight: 3, paddingTop: 1, backgroundColor: "#f5f5f5" }}>
                <Grid container>
                    <Grid item xs={12} sx={{ mt: 2, mb: 2 }}>
                        <Button variant='contained' fullWidth color='error' onClick={() => gotoTrackOrder()}>
                            Tow Status
                        </Button>
                    </Grid>

                    
                    {screen === 1 &&
                        <>
                            <Grid container alignItems={'center'} item xs={12} sx={{ marginBottom: 1 }} flexDirection={'row'}>
                                <Grid item xs={12}>
                                    {pickupLocation && pickupLocation[0] && isGoogleMapsLoaded ? 
                                        <AddressPicker
                                            lat={pickupLocation[0]}
                                            lng={pickupLocation[1]}
                                            fetchAddressOnPointerChange={(lat, lng) => {
                                                fetchAddressOnPointerChange(lat, lng);
                                                setPickupLocation([lat, lng]);
                                            }}
                                            setFormCoordinates={setFormCoordinates}
                                            onLocationValidation={handleLocationValidation}
                                            onAccuracyChange={handleAccuracyChange}
                                            // NEW: Pass GPS accuracy data from NewRequest
                                            initialGpsAccuracy={gpsAccuracy}
                                            initialAccuracyStatus={accuracyStatus}
                                            initialLocationSource={gpsAccuracy ? 'gps' : 'manual'}
                                            locationServicesEnabled={locationServicesEnabled}
                                        /> : (
                                            <Box display="flex" justifyContent="center" alignItems="center" height="400px">
                                                <Typography>Loading map...</Typography>
                                            </Box>
                                        )
                                    }
                                </Grid>
                            </Grid>

                            <Grid container alignItems={'center'} item xs={12} sx={{ marginBottom: 1 }} flexDirection={'row'}>
                                {savedNote && (
                                    <Grid item xs={12} sx={{ marginBottom: 1 }}>
                                        <Box sx={{
                                            border: "1px solid #1976d2",
                                            borderRadius: "4px",
                                            padding: "10px",
                                            backgroundColor: "#e3f2fd",
                                            color: "#0d47a1"
                                        }}>
                                            <Typography variant="body1" sx={{ fontWeight: "bold" }}>Note:</Typography>
                                            <Typography variant="body2">{savedNote}</Typography>
                                        </Box>
                                    </Grid>
                                )}

                                <Grid item xs={12}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleOpenNoteDialog}
                                    >
                                        {savedNote ? "Edit Note" : "Add Note"}
                                    </Button>
                                </Grid>

                                <Dialog open={openNoteDialog} onClose={handleCloseNoteDialog}>
                                    <DialogTitle>{savedNote ? "Edit Note" : "Add Note"}</DialogTitle>
                                    <DialogContent>
                                        <TextField
                                            label="Note"
                                            variant="outlined"
                                            multiline
                                            rows={4}
                                            fullWidth
                                            value={note}
                                            onChange={(e) => setNote(e.target.value)}
                                        />
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleCloseNoteDialog} color="secondary">
                                            Cancel
                                        </Button>
                                        <Button
                                            onClick={handleSaveNote}
                                            color="primary"
                                            disabled={!note.trim()}
                                        >
                                            Save
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            </Grid>

                          <Grid container alignItems={'center'} item xs={12} sx={{ marginBottom: 1 }} flexDirection={'row'}>
                                <Grid item xs={6}>
                                    <Typography className={classes.labelName} sx={{ marginBottom: "0px !important " }}>Pick Up Location</Typography>
                                </Grid>
                            </Grid>

                            {isGoogleMapsLoaded &&
                                <Grid item xs={12}>
                                    <AutoComplete 
                                        map={null}
                                        mapApi={window.google?.maps}
                                        addplace={addPlace} 
                                        updatedValue={pickupLocationDetails.addressLine} 
                                        onChangeHandler={onChangePickupHandler}
                                        fetchAddressOnPointerChange={(lat, lng) => { fetchAddressOnPointerChange(lat, lng); }}
                                        lng={pickupLocation && pickupLocation[1] ? pickupLocation[1] : null}
                                        lat={pickupLocation[0] ? pickupLocation[0] : null} 
                                        setIsGpsEnabled={(val) => { setIsGpsEnabled(val); }} 
                                    />
                                </Grid>
                            }

                            <Grid item xs={12}>
                                <TextField
                                    label="additional Info (Optional)"
                                    variant="outlined"
                                    className={classes.valueStyle}
                                    fullWidth
                                    onChange={(e) => { onChangePickupHandler(e, 'landmark'); }}
                                    value={pickupLocationDetails.landmark}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="City"
                                    variant="outlined"
                                    className={classes.valueStyle}
                                    fullWidth
                                    onChange={(e) => { onChangePickupHandler(e, 'city'); }}
                                    value={pickupLocationDetails.city}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="State"
                                    variant="outlined"
                                    className={classes.valueStyle}
                                    fullWidth
                                    onChange={(e) => { onChangePickupHandler(e, 'state'); }}
                                    value={pickupLocationDetails.state}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Postal Code"
                                    variant="outlined"
                                    className={classes.valueStyle}
                                    fullWidth
                                    onChange={(e) => { onChangePickupHandler(e, 'postalCode'); }}
                                    value={pickupLocationDetails.postalCode}
                                />
                            </Grid>
                        </>
                    }

                    {screen === 2 &&
                        <>
                            <Grid item xs={4} sx={{ mt: 1 }}>
                                <Typography className={classes.labelName}># of Vehicles to Tow</Typography>
                            </Grid>
                            <Grid item xs={8} sx={{ mt: 1 }} container justifyContent={'flex-end'} alignItems="flex-start">
                                <Button component="span" sx={{ p: 0 }} className={classes.buttonStyle} onClick={removeTowingCount}><RemoveCircle /></Button>
                                <Typography className={classes.valueStyle}>{towCount}</Typography>
                                <Button component="span" sx={{ p: 0 }} className={classes.buttonStyle} onClick={addTowingCount}><AddCircle /></Button>
                            </Grid>
                            <Grid item xs={4} sx={{ mt: 1 }}>
                                <Typography className={classes.labelName}># of Tow Trucks</Typography>
                            </Grid>
                            <Grid item xs={8} sx={{ mt: 1 }} container justifyContent={'flex-end'} alignItems="flex-start">
                                <Button component="span" sx={{ p: 0 }} className={classes.buttonStyle} onClick={removeTruckCount}><RemoveCircle /></Button>
                                <Typography className={classes.valueStyle}>{truckCount}</Typography>
                                <Button component="span" sx={{ p: 0 }} className={classes.buttonStyle} onClick={addTruckCount}><AddCircle /></Button>
                            </Grid>
                            <Grid item xs={4} sx={{ mt: 1 }}>
                                <Typography className={classes.labelName}>Flatbed Required</Typography>
                            </Grid>
                            <Grid item xs={8} container justifyContent={'flex-end'} alignItems="flex-start">
                                <Checkbox
                                    checked={checked}
                                    onChange={(e) => setChecked(e.target.checked)}
                                    color="primary"
                                    icon={<CheckBoxOutlineBlank fontSize="small" />}
                                    checkedIcon={<Check fontSize="small" />}
                                />
                                <Grid>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Grid>
                            </Grid>
                        </>
                    }

                    {screen === 3 &&
                        <>
                            <Grid container justifyContent={'flex-end'}>
                                <ImageUploader handleCapture={handleCapture} />
                            </Grid>
                            <Grid item xs={12}>
                                {thumbnailImgs.length > 0 ? (
                                    <Slider {...settings}>
                                        {thumbnailImgs.map((imgURL, index) => (
                                            <Box
                                                key={index}
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                sx={{
                                                    height: { xs: '200px', sm: '250px' },
                                                    width: '100%',
                                                    overflow: 'hidden'
                                                }}
                                            >
                                                <Box
                                                    component="img"
                                                    src={imgURL}
                                                    alt={`Thumbnail ${index + 1}`}
                                                    sx={{
                                                        height: '100%',
                                                        width: 'auto',
                                                        objectFit: 'cover',
                                                        display: 'block',
                                                    }}
                                                />
                                            </Box>
                                        ))}
                                    </Slider>
                                ) : (
                                    <Box display="flex" justifyContent="center" alignItems="center" sx={{ height: '250px' }}>
                                        <Avatar variant='square' className={classes.avatar}>
                                        </Avatar>
                                    </Box>
                                )}
                            </Grid>
                        </>
                    }

                    {screen === 4 &&
                        <Grid container justifyContent={'center'} alignItems="center" sx={{ minHeight: 300 }}>
                            <Grid m={3} container direction="column" alignItems="center">
                                <Typography>{responseMessage}<br /></Typography>
                                <Button color="secondary" onClick={gotoTrackOrder}>Track Order</Button>
                            </Grid>
                        </Grid>
                    }

                    <Grid item xs={12} sx={{ mt: 10, mb: 3 }}>
                        {screen < 3 &&
                            <Button 
                                variant='contained' 
                                disabled={
                                    !isValid || 
                                    (shouldBlockForGPSAccuracy() && gpsAccuracy && gpsAccuracy > GPS_ACCURACY_THRESHOLD)
                                } 
                                fullWidth 
                                className={classes.requestButton} 
                                onClick={handleNext}
                            >
                                Next
                            </Button>
                        }
                        {screen === 3 &&
                            <Button
                                disabled={
                                    profilePics.length === 0 || 
                                    (shouldBlockForGPSAccuracy() && gpsAccuracy && gpsAccuracy > GPS_ACCURACY_THRESHOLD)
                                }
                                variant='contained'
                                fullWidth
                                className={classes.requestButton}
                                onClick={handleSubmit}
                            >
                                Request Tow
                            </Button>
                        }
                        <br />
                        <br />
                        {screen < 4 &&
                            <>
                                <Button variant='contained' fullWidth color='error' onClick={() => handleBack(false)}>
                                    Back
                                </Button>
                            </>
                        }
                    </Grid>
                </Grid>
            </Box>

            {/* Enhanced Location Permission Dialog */}
            <LocationPermissionDialog 
                open={showLocationPermissionDialog}
                onClose={() => setShowLocationPermissionDialog(false)}
                onRefresh={handleLocationPermissionRefresh}
                onManualEntry={handleLocationPermissionManualEntry}
                gpsAccuracySetting={gpsAccuracySetting}
            />

            {/* GPS Accuracy Dialog */}
            <GPSAccuracyDialog
                open={showGPSAccuracyDialog}
                onRefreshGPS={handleGPSAccuracyRefresh}
                onManualEntry={handleGPSAccuracyManualEntry}
                accuracy={gpsAccuracy}
                onClose={() => {
                    if (!shouldBlockForGPSAccuracy()) {
                        setShowGPSAccuracyDialog(false);
                    }
                }}
            />

            {/* Location Verification Dialog */}
            <LocationVerificationDialog
                open={showLocationVerification}
                onClose={() => setShowLocationVerification(false)}
                onConfirm={handleLocationVerificationResult}
                onRetryGPS={handleRetryGPS}
                locationData={pendingLocationData}
                addressDetails={pickupLocationDetails}
            />

            {/* Form Submission Handler */}
            <FormSubmissionHandler
                isSubmitting={isSubmitting}
                error={submitError}
                onRetry={handleSubmit}
                onClose={() => setSubmitError(null)}
            />
        </>
    );
};

export default NewRequest;